// extracted by mini-css-extract-plugin
module.exports = {"people-container":"peopleManageMentDialog_people-container_18ZPZ","table":"peopleManageMentDialog_table_IoCKT"};